import React, { useState } from "react";
import { getIn } from "formik";
import { Box, IconButton, Typography, FormControl, CircularProgress } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import ClearIcon from '@mui/icons-material/Clear';
export const FileUploadFormField = ({ field, form, label, isRequired, ...props }) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
    const [ previewUrl, setPreviewUrl] = useState(
        field.value ? URL.createObjectURL(field.value) : null
    );
    const [isUploading, setIsUploading] = useState(false);
    const [error, setError] = useState(getIn(form.errors, field.name));

    const handleUpload = async (event) => {
        if (!event.target.files) return;

        setError("");
        const file = event.target.files[0];
        if (!file) return;

        // Validate File Type
        if (!file.type.startsWith("image/")) {
            setError("Only image files are allowed.");
            return;
        }

        // Validate File Size (Max 5MB)
        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            setError("File size should be less than 5MB.");
            return;
        }


        // Generate Local Preview
        const imageUrl = URL.createObjectURL(file);
        setPreviewUrl(imageUrl);

        // Simulate Upload (Replace with API call if needed)
        setIsUploading(true);
        setTimeout(() => {
            form.setFieldValue(field.name, file);
            setIsUploading(false);
        }, 2000);
    };

    const handleRemove = () => {
        setPreviewUrl(null);
        form.setFieldValue(field.name, "");
    };

    return (
        <>
            <FormControl
                fullWidth
                sx={{
                    border: "1px dashed #4169E1",
                    backgroundColor: "#F7FAFF",
                    borderRadius: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    py: "16px",
                    textAlign: "center",
                }}
            >
                <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
                    {!previewUrl ? (
                        <>
                            <IconButton
                                component="label"
                                sx={{
                                    bgcolor: "#E9EFFF",
                                    borderRadius: "50%",
                                    padding: 2,
                                }}
                            >
                                <CameraAltIcon sx={{ fontSize: "24px", color: "#4169E1" }} />
                                <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={handleUpload}
                                />
                            </IconButton>
                            <Typography variant="h6" color="#4169E1">
                                {label}
                            </Typography>
                        </>
                    ) : !isUploading ? <Box position="relative">
                        <img
                            src={previewUrl}
                            alt="Uploaded"
                            style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "8px",
                            }}
                        />
                        <IconButton
                            sx={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                p: 0,
                                bgcolor: "rgba(255, 255, 255, 0.7)",
                            }}
                            onClick={handleRemove}
                        >
                            <ClearIcon sx={{ fontSize: "20px", color: "#000" }} />
                        </IconButton>
                    </Box> : <CircularProgress size={20} sx={{ mt: 1, color: "#000" }} />}
                </Box>
            </FormControl>
            {error && <Typography variant="h6" fontSize={"10px"} color="red">{error}</Typography>}
            {errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
        </>

    );
};






